export default __webpack_public_path__ + "src/images/btn_lan_cn-b94185.png";